import { useAtom } from 'jotai';
import { commandMenuOpenedAtom } from '~/atoms/atoms';

export function useCommandMenu() {
  const [commandMenuOpened, setCommandMenuOpened] = useAtom(commandMenuOpenedAtom);

  return {
    commandMenuOpened,
    openCommandMenu: () => setCommandMenuOpened(true),
    closeCommandMenu: () => setCommandMenuOpened(false),
    toggleCommandMenu: () => {
      setCommandMenuOpened((prev) => !prev);
    },
  };
}
